import { LocaleEnum } from "@/types/utils/locale";

export function formatterMoney(params: string | number) {
  return new Intl.NumberFormat(LocaleEnum.EN).format(Number(params));
}

export function stringToNumber(strNumber?: string | number | null) {
  if (!strNumber) return 0;
  if (typeof strNumber === "number") return strNumber;
  const toNubmer = Number(strNumber);
  if (Number.isNaN(toNubmer)) return 0;
  return toNubmer;
}

export function numberToLocaleString(
  number: number,
  option?: Intl.NumberFormatOptions,
) {
  if (typeof number !== "number") {
    // console.error("function toLocaleString: input is not a number");
    return number;
  }
  return number.toLocaleString(LocaleEnum.EN, {
    ...option,
  });
}
